const _import = require('@/utils/import/_import_' + process.env.NODE_ENV)
import create from './create'

const routes = [
  {
    path: 'properties',
    name: 'Properties',
    component: {
      template: '<div class="content-wrapper"><router-view></router-view></div>',
    },
    meta: {
      title: 'Настройки',
      menuKey: 'Settings',
      roles: ['ROLE_ADMIN', 'ROLE_WAITER']
    },
    children: [
      {
        path: '',
        name: 'Properties.list',
        component: _import('settings/components/Properties/list'),
        meta: {
          title: 'Свойства',
          roles: ['ROLE_ADMIN', 'ROLE_WAITER']
        }
      },
      {
        path: 'create',
        name: 'Properties.create',
        component: _import('settings/components/Properties/create'),
        meta: {
          title: 'Добавление свойства',
          roles: ['ROLE_ADMIN', 'ROLE_WAITER']
        }
      },
      {
        path: ':id/edit',
        name: 'Properties.edit',
        component: _import('settings/components/Properties/edit'),
        meta: {
          title: 'Изменение свойства',
          roles: ['ROLE_ADMIN', 'ROLE_WAITER']
        }
      }
    ]
  }
]

routes.forEach(route => {
  route.children.forEach(child => {
    child.meta.menuKey = route.meta.menuKey
  })
})

export default routes



// WEBPACK FOOTER //
// ./src/modules/settings/components/Properties/routes.js